import HomeApp from "./Pages/index";

function App() {
  return (
    <div className="App">
      <HomeApp />
    </div>
  );
}

export default App;
